<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex" justify="center">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :errors.sync="errors"
        :form.sync="form"
        :edit-mode="editMode"
        :rules="rules"
      >
        <el-form-item label="名称：" required prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <el-form-item label="充值金额：" required prop="recharge_money">
          <el-input-number
            v-model="form.recharge_money"
            :precision="0"
            :step="1"
            :max="1000"
          />
        </el-form-item>
        <el-form-item label="赠送金额：" required prop="give_money">
          <el-input-number
            v-model="form.give_money"
            :precision="0"
            :step="1"
            :max="500"
          />
        </el-form-item>
        <!-- <el-form-item
          label="折扣："
          required
          prop="discount"
        >
          <el-input-number
            v-model="form.discount"
            :precision="2"
            :step="0.01"
            :max="1"
          />
        </el-form-item> -->
        <el-form-item label="区域" required prop="area_name">
          <el-select
            filterable
            clearable
            v-model="form.area_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用：" required prop="status">
          <el-radio v-model="form.status" :label="status1" border>启用</el-radio>
          <el-radio v-model="form.status" :label="status0" border>停用</el-radio>
        </el-form-item>
        <el-form-item label="开始时间" required prop="start_at">
          <el-date-picker
            v-model="form.start_at"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item label="结束时间" required prop="end_at">
          <el-date-picker
            v-model="form.end_at"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <!-- <el-form-item label="权限" prop="permissions">
                          <el-select
                            v-model="form.permissions"
                            multiple
                            placeholder="选择权限"
                            filterable
                            clearable
                          >
                            <el-option
                              v-for="i of permissions"
                              :key="i.id"
                              :label="i.name"
                              :value="i.id"
                            />
                          </el-select>
                        </el-form-item> -->
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import {
  storeRechargeConfiguration,
  editRechargeConfiguration,
  updateRechargeConfiguration,
} from '@/api/recharge-configuration'
import { getAreas } from '@/api/area'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        name: '',
        give_money: 0,
        discount: 1,
        recharge_money: 0,
        status: 0,
        area_id: '',
        start_at: '',
        end_at: '',
      },
      rules: {},
      errors: {},
      areas: [],
      status1: 1,
      status0: 0,
    }
  },
  methods: {
    async onSubmit() {
      if (this.editMode) {
        await updateRechargeConfiguration(this.resourceId, this.form)
      } else {
        await storeRechargeConfiguration(this.form)
      }
    },
    async getData() {
      const [
        { data: areas },
      ] = await Promise.all([
        getAreas({ all: 1 }),
      ])

      this.areas = areas

      if (this.editMode) {
        const { data } = await editRechargeConfiguration(this.resourceId)
        // data.areas = data.areas.map(i => i.id)
        this.fillForm(data)
      }
    },
  },
}
</script>
